import { CustomMarkerData } from 'src/app/interfaces/map.interface';
import { CustomMarkerBuilder } from './custom-marker.builder';

export abstract class NonAggregatedMarkerBuilder<TEntity> extends CustomMarkerBuilder {
  public setCustomMarkerData(data: TEntity): void {
    this.marker.data = this.getCustomMarkerData(data);
  }

  protected abstract getCustomMarkerData(data: TEntity): CustomMarkerData;
}
